import { IS_MOCKED_CLIENT } from '../config';
import type { ThemeKey } from '../types';

let systemThemeCache: ThemeKey = (
  window.matchMedia?.('(prefers-color-scheme: dark)').matches
) ? 'dark' : 'light';

let themeChangeCallback: ((newTheme: ThemeKey) => void) | undefined;

export function getSystemTheme() {
  if (IS_MOCKED_CLIENT){
    return 'light';
  }
  return systemThemeCache;
}

function handleSystemThemeChange(e: MediaQueryListEventMap['change']) {
  if (IS_MOCKED_CLIENT){
    systemThemeCache = 'light';
  } else {
    systemThemeCache = e.matches ? 'dark' : 'light';
  }

  themeChangeCallback?.(systemThemeCache);
}

export function setSystemThemeChangeCallback(callback: (newTheme: ThemeKey) => void) {
  themeChangeCallback = callback;
}

window.matchMedia('(prefers-color-scheme: dark)')
  .addEventListener('change', handleSystemThemeChange);
